import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import CriticalIllnessTabImage from "../../Assets/Images/critical-illness-tab-image.jpg";
import CriticalIllnessTabImage1920 from "../../Assets/Images/Critical-1921.png";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import CoveredFull from "./CoveredFull";
import CoveredHalf from "./CoveredHalf";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const componentMap = {
  COVEREDFULL: <CoveredFull />,
  COVEREDHALF: <CoveredHalf />,
};
const CriticalIllnessTab = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("COVEREDFULL");

  return (
    <div
      id="critical-illness-covered"
      className="supeior-rating py-20 lg:pb-36 lg:mb-36 mb-12 [@media(min-width:1920px)]:min-h-screen [@media(min-width:1920px)]:flex [@media(min-width:1920px)]:items-center"
    >
      <div className="relative lg:absolute w-[100%] lg:w-[50%] pr-[20px] left-0 lg:block hidden">
        <div className="flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
          <div className="ml-[20px] lg:ml-0 mb-[10%] md:mb-0 max-h-[688px] [@media(min-width:1920px)]:!max-h-[1260px] reveal-up">
            <img
              src={CriticalIllnessTabImage}
              width={"100%"}
              className="object-cover rounded-br-[600px] rounded-tr-[600px] max-h-[860px] [@media(min-width:1920px)]:!hidden"
              alt=""
            />
            <img
              src={CriticalIllnessTabImage1920}
              width={"100%"}
              className="hidden [@media(min-width:1920px)]:!block object-cover rounded-br-[900px] rounded-tr-[900px] max-h-[1260px]"
              alt=""
            />
          </div>
        </div>
      </div>
      <Container>
        <div className="">
          <div className="reveal-up mt-0 lg:mt-28 lg:ml-[50%] lg:pl-[5rem] critical-illness-covered-header">
            <h3 className="text-[24px] md:text-[30px] xl:text-[40px] [@media(min-width:1920px)]:!text-[60px] [@media(min-width:1920px)]:!leading-[66px] [@media(min-width:1920px)]:!tracking-[-1.2px] mb-2 md:leading-[33px] xl:leading-[44px] leading-[28px] font-semibold max-w-[530px] [@media(min-width:1920px)]:!max-w-[652px] lg:mb-5 mb-4 lg:pr-0 pr-10 extra-title-heading">
              {translations.criticalIllnessTab1.heading}
            </h3>
            <div className="bordertitle-line mb-4"></div>
            <div className="active-section flex lg:justify-center justify-space-between  bg-white rounded-full lg:mt-7 mt-12 mb-4 md:max-w-[530px] max-w-[281px] lg:max-w-[400px] xl:max-w-[530px] [@media(min-width:1920px)]:!max-w-[620px]">
              <button
                onClick={() => setChange("COVEREDFULL")}
                className={`md:flex-1 content text-[12px] md:text-[10.5px] xl:text-[12px] [@media(min-width:1920px)]:!text-[18px] [@media(min-width:1920px)]:!leading-[25.2px] [@media(min-width:1920px)]:!tracking-[-0.36px] extra-btn-font ${
                  change === "COVEREDFULL"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "COVEREDFULL" ? "text-black" : "text-black"
                } py-3 lg:py-2 xl:py-3 [@media(min-width:1920px)]:!py-[15px] px-4 lg:px-3 xl:px-4 [@media(min-width:1920px)]:!px-9 rounded-full md:w-1/3`}
              >
                {translations.criticalIllnessTab1.coveredFull}
              </button>
              <button
                onClick={() => setChange("COVEREDHALF")}
                className={`md:flex-1 content text-[12px] md:text-[10.5px] xl:text-[12px] [@media(min-width:1920px)]:!text-[18px] [@media(min-width:1920px)]:!leading-[25.2px] [@media(min-width:1920px)]:!tracking-[-0.36px] extra-btn-font ${
                  change === "COVEREDHALF"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "COVEREDHALF" ? "text-black" : "text-black"
                } py-3 lg:py-2 xl:py-3 [@media(min-width:1920px)]:!py-[15px] px-4 lg:px-3 xl:px-4 [@media(min-width:1920px)]:!px-9 rounded-full md:w-1/3`}
              >
                {translations.criticalIllnessTab1.coveredHalf}
              </button>
            </div>
            {componentMap[change] || null}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CriticalIllnessTab;
